const globals = {
    spatialNames: [],
    layers: []
};

export default globals;